import React, { useState } from "react";
import { makeStyles, withStyles, useTheme } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";
import Popover from "@material-ui/core/Popover";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { BiSupport } from "react-icons/bi";
import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@material-ui/core";
import { detectIfFreshchatHasLoaded } from "../../services/freshchat";

export default function HelpDropDown() {
  const classes = useStyles();
  const theme = useTheme();
  let history = useHistory();

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <>
      <IconButton aria-describedby={id} onClick={handleClick}>
        <BiSupport />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Box
          className={classes.typography}
          style={{
            background: theme.palette.type === "dark" ? "#151828" : "white",
            minWidth: "180px",
          }}
        >
          <List>
            <ListItem
              button
              onClick={() => {
                if (detectIfFreshchatHasLoaded()) {
                  document.querySelector(
                    "#fc_frame, #fc_frame.fc-widget-normal"
                  ).style.display = "block";
                  window.fcWidget.open();
                  window.fcWidget.show();
                }
              }}
            >
              <ListItemText primary="Chat with Us"></ListItemText>
            </ListItem>
            <ListItem
              button
              onClick={() => {
                window.open(
                  "https://support.pocketbits.in/support/solutions",
                  "_blank",
                  "nofollow,noopener,noreferrer"
                );
              }}
            >
              <ListItemText primary="Support Center"></ListItemText>
            </ListItem>
          </List>
        </Box>
      </Popover>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  typography: {
    padding: theme.spacing(2),
  },
}));
